import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { CurrencySymbol } from '../../../Utility/Constants'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

export default function AutoBilling() {
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Auto Billing", "SubTab")?.editAccess
    const [filteredServiceList, setFilteredServiceList] = useState(null);
    const [filterdepartment, setFilterDepartment] = useState('');
    const [filterHead, setFilterHead] = useState(null);
    const [filterName, setFilterName] = useState(null);
    const [moduleList, setModuleList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [HeaderList, setHeaderList] = useState([]);
    const [wardList, setWardList] = useState([]);
    const [ServiceList, setServiceList] = useState([]);
    const [PatientTypeList, setPatientTypeList] = useState([])
    const [AutoBillingList, setAutoBillingList] = useState([])
    const [selectedService, setSelectedService] = useState([])
    const [formState, setFormState] = useState({
        departmentType: '',
        serviceHeadCode: '',
        serviceHead: '',
        serviceName: '',
        serviceCode: '',
        patientType: '',
        selectedDoctorId: null,
        selectedWardId: null,
        serviceCharge: '',
        serviceChargeId: '',
        selSpecialization: null
    });
    const [doctorList, setDoctorList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [specilationList, setSpecilationList] = useState([]);
    const [DoctorList, setdoctorList] = useState([]);
    // const patient_type = ['All', 'New Patient', 'Review Patient', 'Old Patient']

    useEffect(() => {
        getAutoBillingList();
        getModuleList();
        getSpecializationList();
        getDoctorList();
    }, [])

    const getModuleList = () => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_AUTO_SUMMARY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const ModuleData = response.data.data || [];
                        setOriginalList(ModuleData);
                        setModuleList(Object.keys(ModuleData));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getSpecializationList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let ListData = response.data.data || [];
                        let updatedData = [{ id: "All", name: "All" }, ...ListData];
                        setSpecilationList(updatedData);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const doctorData = response.data.data || [];
                        setdoctorList(doctorData);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getAutoBillingList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_AUTO_BILLING_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const apiData = response.data.data || [];

                        const data = apiData.map((item, index) => ({
                            ...item,
                            sno: index + 1,
                        }));

                        setAutoBillingList(data)
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = AutoBillingList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item?.service_charge_id)
            })
            setdelIDs(FinalData)
        }

        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.015, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params?.row?.sno}</Typography>)
            },
            {
                field: 'module', headerName: 'Module', flex: 0.045,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.module ? params?.row?.module : '-'}</Box>)
            },
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.17,
                renderCell: (params) => (params.row.service_head ? params.row.service_head?.length > 25 || params.row.service_head_code?.length > 10 ?
                    <Tooltip placement="top" title={`${params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}${params.row.service_head}`}><Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{params.row.service_head.slice(0, 22) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{params.row.service_head}</Typography> : '-')
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.17,
                renderCell: (params) => (params.row.service_name ? params.row.service_name?.length > 25 || params.row.service_code?.length > 10 ?
                    <Tooltip placement="top" title={`${params.row.service_code ? params.row.service_code + ' - ' : ''}${params.row.service_name}`}><Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name.slice(0, 22) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name}</Typography> : '-')
            },
            {
                field: 'service_charge', headerName: 'Service Charge', flex: 0.12, align: "left",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_charge ? Number(params.row.service_charge).toFixed(2) : '0.00'}</Box>)
            },
            {
                field: 'doctor_name', headerName: 'Doctor Name', flex: 0.15,
                renderCell: (params) => (params.row.doctor_name?.trim() ?
                    params.row.doctor_name?.length > 25 ? <Tooltip placement="top" title={`${params.row.doctor_name ? params.row.doctor_name + ' - ' : ''}`}><Typography fontSize={'0.9vw'}>{params.row.doctor_name.slice(0, 22) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.doctor_name}</Typography> : 'All')
            },
            {
                field: 'specialization_name', headerName: 'Specialization', flex: 0.15,
                renderCell: (params) => (params.row.specialization_name?.trim() ?
                    params.row.specialization_name?.length > 25 ? <Tooltip placement="top" title={`${params.row.specialization_name ? params.row.specialization_name + ' - ' : ''}`}><Typography fontSize={'0.9vw'}>{params.row.specialization_name.slice(0, 22) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.specialization_name}</Typography> : '-')
            },
            {
                field: 'ward_name', headerName: 'Ward Name', flex: 0.13,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.ward_name ? params?.row?.ward_name : params?.row?.module != "OP" ? "All" : '-'}</Box>)
            }
        ]
        return (
            <Box sx={{ height: '54vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={AutoBillingList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    pagination
                    paginationMode="client"
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    pageSizeOptions={[10, 20, 30]}
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setPage(model.page)
                        setPageSize(model.pageSize)
                    }}
                    rowCount={AutoBillingList.length}
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setFormState({
            departmentType: '',
            serviceHeadCode: '',
            serviceHead: '',
            serviceName: '',
            serviceCode: '',
            patientType: '',
            selectedDoctorId: null,
            selectedWardId: null,
            serviceCharge: '',
            serviceChargeId: '',
            selSpecialization: null
        })
        setPatientTypeList([])
        setSelectedService([])
        setFilterDepartment('');
        setFilterHead(null);
        setFilterName(null);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }
    const addAutoBilling = () => {
        try {
            if (!formState?.serviceChargeId) {
                return errorMessage('Please Select All mandatory fields')
            }
            let data = {
                'service_charge_id': formState?.serviceChargeId,
                'specialization_id': formState?.selSpecialization?.id || null
            }
            setisloader(true)
            RestAPIService.create(data, Serviceurls.NEW_AUTO_BILLING_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getAutoBillingList()
                        getModuleList()
                        clearFunction()
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const DeleteAutoBillingData = () => {
        try {
            setisloader(true)
            let data = {
                "service_charge_id": delIDs,
            }
            RestAPIService.delete(`${Serviceurls.NEW_AUTO_BILLING_LIST}`, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        closeFilter();
                        getAutoBillingList();
                        clearFunction()
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const filterDoctorsAndWards = (patientType, charges) => {
        const filteredDoctors = [];
        const filteredWards = [];
        const seenDoctors = new Set();
        const seenWards = new Set();
        let nullDoctorCharge = null;
        let nullWardCharge = null;

        const doctorIdCount = {};
        const wardIdCount = {};

        // Count unique doctor_id and ward_id
        charges.forEach(charge => {
            if (charge.patient_type !== patientType) return;

            if (charge.doctor_id !== null) {
                doctorIdCount[charge.doctor_id] = true;
            } else if (charge.service_charge && charge.service_charge_id) {
                nullDoctorCharge = charge;
            }

            if (charge.ward_id !== null) {
                wardIdCount[charge.ward_id] = true;
            } else if (charge.service_charge && charge.service_charge_id) {
                nullWardCharge = charge;
            }
        });
        charges.forEach(charge => {
            if (charge.patient_type === patientType) {
                if (charge.doctor_id && !seenDoctors.has(charge.doctor_id)) {
                    seenDoctors.add(charge.doctor_id);
                    filteredDoctors.push({
                        doctor_id: charge.doctor_id,
                        doctor_name: charge.doctor_name
                    });
                }

                if (charge.ward_id && !seenWards.has(charge.ward_id)) {
                    seenWards.add(charge.ward_id);
                    filteredWards.push({
                        service_charge: charge.service_charge,
                        service_charge_id: charge.service_charge_id,
                        ward_id: charge.ward_id,
                        ward_name: charge.ward_name
                    });
                }
            }
        });

        if (nullDoctorCharge) {
            filteredDoctors.unshift({
                doctor_id: null,
                doctor_name: "All"
            });
        }

        // Only one null ward — add as "All"
        if (nullWardCharge) {
            filteredWards.unshift({
                ward_id: null,
                ward_name: "All",
                service_charge: nullWardCharge.service_charge,
                service_charge_id: nullWardCharge.service_charge_id
            });
        }

        setDoctorList(filteredDoctors);
        setWardList(filteredWards);

        // Auto-select if only one doctor or ward
        let selDoc = DoctorList.find((item) => item?.doctor_id == filteredDoctors[0]?.doctor_id);
        let Specialization = specilationList.find((item) => item?.id == selDoc?.specialization_id);
        setFormState(prev => ({
            ...prev,
            selectedDoctorId: filteredDoctors.length === 1 ? filteredDoctors[0] : null,
            selectedWardId: filteredWards.length === 1 ? filteredWards[0] : null,
            serviceCharge: filteredDoctors.length === 1 && filteredWards.length === 1 ? filteredWards[0].service_charge : "",
            serviceChargeId: filteredDoctors.length === 1 && filteredWards.length === 1 ? filteredWards[0].service_charge_id : "",
            selSpecialization: Specialization,
        }));
    };

    const filterWardsByDoctor = (doctorId, patientType, charges) => {
        const filteredWards = [];
        const seenWards = new Set();
        let nullWardCharge = null;
        const wardIdCount = {};

        charges.forEach(charge => {
            if (charge.patient_type !== patientType) return;
            if (charge.ward_id !== null && charge.doctor_id === doctorId) {
                wardIdCount[charge.ward_id] = true;
            } else if (charge.service_charge_id && charge.doctor_id === doctorId) {
                nullWardCharge = charge;
            }
        });

        charges.forEach(charge => {
            if (
                charge.patient_type === patientType &&
                charge.doctor_id === doctorId &&
                charge.ward_id &&
                !seenWards.has(charge.ward_id)
            ) {
                seenWards.add(charge.ward_id);
                filteredWards.push({
                    service_charge: charge.service_charge,
                    service_charge_id: charge.service_charge_id,
                    ward_id: charge.ward_id,
                    ward_name: charge.ward_name
                });
            }
        });
        if (nullWardCharge) {
            filteredWards.unshift({
                ward_id: null,
                ward_name: "All",
                service_charge: nullWardCharge.service_charge,
                service_charge_id: nullWardCharge.service_charge_id
            });
        }
        setWardList(filteredWards);
        let DocID = doctorList.find(doc => doc.doctor_id === doctorId)
        let selDoc = DoctorList.find((item) => item?.doctor_id == DocID?.doctor_id);
        let Specialization = specilationList.find((item) => item?.id == selDoc?.specialization_id);
        setFormState(prev => ({
            ...prev,
            selectedDoctorId: DocID,
            selectedWardId: filteredWards.length === 1 ? filteredWards[0] : null,
            serviceCharge: filteredWards.length === 1 ? filteredWards[0].service_charge : "",
            serviceChargeId: filteredWards.length === 1 ? filteredWards[0].service_charge_id : "",
            selSpecialization: Specialization,
        }));
    };


    const onServiceSelected = (service) => {
        if (!service) return;
        setSelectedService(service)
        const charges = Array.isArray(service.service_charge) ? service.service_charge : [];

        // Unique Patient Types
        const patientTypeSet = new Set();
        // Unique Doctors
        const doctorMap = new Map();
        // Unique Wards
        const wardMap = new Map();

        charges.forEach(charge => {
            if (charge.patient_type) patientTypeSet.add(charge.patient_type);

            if (charge.doctor_id && charge.doctor_name) {
                doctorMap.set(charge.doctor_id, {
                    doctor_id: charge.doctor_id,
                    doctor_name: charge.doctor_name
                });
            }

            if (charge.ward_id && charge.ward_name) {
                wardMap.set(charge.ward_id, {
                    ward_id: charge.ward_id,
                    ward_name: charge.ward_name
                });
            }
        });

        const uniquePatientTypes = Array.from(patientTypeSet);
        const uniqueDoctors = Array.from(doctorMap.values());
        const uniqueWards = Array.from(wardMap.values());

        setPatientTypeList(uniquePatientTypes);
        setDoctorList(uniqueDoctors);
        setWardList(uniqueWards);

        // Auto-select if only one exists
        if (uniquePatientTypes.length === 1) {
            setFormState((prev) => ({ ...prev, patientType: uniquePatientTypes[0] }));
            filterDoctorsAndWards(uniquePatientTypes[0], charges);
        } else {
            setFormState((prev) => ({ ...prev, patientType: "", selectedDoctorId: null, selectedWardId: null, serviceCharge: '', selSpecialization: null  }));
        }

        // setFormState((prev) => ({
        //     ...prev,
        //     selectedDoctorId: "",
        //     selectedWardId: "",
        //     serviceCharge: ""
        // }));
    };


    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '18vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                {/* <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}> */}
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Autocomplete
                            options={moduleList}
                            clearIcon={false}
                            value={filterdepartment}
                            sx={{ mr: '1vw' }}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') {
                                    const moduleMapping = {
                                        IP: "IN PATIENT",
                                        OP: "OUT PATIENT",
                                        IP_OP: "BOTH IP & OP",
                                    };
                                    return moduleMapping[option] || option;
                                }
                            }}
                            onChange={(event, value) => {
                                let selectedModule = originalList[value] || [];
                                const serviceDetailsArray = selectedModule.flatMap(item =>
                                    item?.service_details.map(service => ({
                                        ...service,
                                        head_name: item.head_name,
                                        service_head_code: item.service_head_code
                                    }))
                                );
                                setFilterDepartment(value);
                                setHeaderList(selectedModule);
                                setServiceList(serviceDetailsArray);
                                setFilteredServiceList(serviceDetailsArray);
                                setFilterHead(null);
                                setFilterName(null);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Module *"
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: "20vw" }}
                                />
                            )}
                        />

                        <Autocomplete
                            options={HeaderList}
                            clearIcon={false}
                            value={filterHead}
                            disabled={!filterdepartment}
                            getOptionLabel={(option) => option?.head_name}
                            sx={{ mr: '1vw' }}
                            onChange={(event, value) => {
                                setFilterHead(value);
                                if (value) {
                                    const mappedServices = ServiceList.filter(service =>
                                        service.service_head_code === value.service_head_code
                                    );
                                    setFilteredServiceList(mappedServices);
                                } else {
                                    setFilteredServiceList(ServiceList);
                                }
                                setFilterName(null);
                                setFormState((prev) => ({ ...prev, patientType: "", selectedDoctorId: null, selectedWardId: null, serviceCharge: '' }));
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Service Head *"
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: "20vw" }}
                                    disabled={!filterdepartment}
                                />
                            )}
                        />
                        <Autocomplete
                            options={filteredServiceList}
                            clearIcon={false}
                            disabled={!filterdepartment}
                            getOptionLabel={(option) => option?.service_name}
                            sx={{ mr: '1vw' }}
                            value={filterName}
                            onChange={(event, value) => {
                                if (value) {
                                    setFilterHead(value); setFilterName(value)
                                    onServiceSelected(value)
                                } else {
                                    setFilterName(value)
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Service Name *"
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: "20vw" }}
                                    disabled={!filterdepartment}
                                />
                            )}
                        />
                        <FormControl sx={{ width: '20vw' }} size='small'>
                            <InputLabel>Patient Type*</InputLabel>
                            <Select
                                label='Patient Type*'
                                sx={{ mr: '1vw' }}
                                value={formState.patientType}
                                onChange={(e) => {
                                    setFormState(prev => ({
                                        ...prev,
                                        patientType: e.target.value,
                                        selectedDoctorId: "",
                                        selectedWardId: ""
                                    }));
                                    filterDoctorsAndWards(e.target.value, selectedService.service_charge);
                                }}
                                disabled={false}
                            >
                                {PatientTypeList?.map(item => (
                                    <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', marginTop: "1dvw" }}>
                    <Autocomplete
                        options={doctorList}
                        clearIcon={false}
                        value={formState?.selectedDoctorId || null}
                        disabled={!filterdepartment}
                        getOptionLabel={(option) => option?.doctor_name}
                        sx={{ mr: '1vw' }}
                        onChange={(event, value) => {
                            if (value) {
                                filterWardsByDoctor(value.doctor_id, formState.patientType, selectedService?.service_charge || []);
                            } else {
                                // Reset if no doctor selected
                                setFormState(prev => ({
                                    ...prev,
                                    selectedDoctorId: "",
                                    selectedWardId: "",
                                    serviceCharge: "",
                                    serviceChargeId: ""
                                }));
                                setWardList([]);
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Doctor Name *"
                                variant="outlined"
                                size="small"
                                sx={{ width: "20vw" }}
                                disabled={!filterdepartment}
                            />
                        )}
                    />
                    <Autocomplete
                        options={specilationList}
                        clearIcon={false}
                        disabled={formState.selectedDoctorId?.doctor_id}
                        value={formState?.selSpecialization || null}
                        getOptionLabel={(option) => option?.name}
                        sx={{ mr: '1vw' }}
                        onChange={(event, value) => {
                            setFormState(prev => ({
                                ...prev,
                                selSpecialization: value,
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Specialization"
                                variant="outlined"
                                size="small"
                                sx={{ width: "20vw" }}
                            />
                        )}
                    />
                    <Autocomplete
                        options={wardList}
                        clearIcon={false}
                        value={filterdepartment === "OP" ? null : formState?.selectedWardId}
                        disabled={filterdepartment === "OP" || !formState?.selectedDoctorId}
                        getOptionLabel={(option) => option?.ward_name}
                        sx={{ mr: '1vw' }}
                        onChange={(event, value) => {
                            setFormState(prev => ({
                                ...prev,
                                selectedWardId: value || null,
                                serviceCharge: value?.service_charge || "",
                                serviceChargeId: value?.service_charge_id || ""
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={filterdepartment === "OP" ? "Ward" : "Ward *"}
                                variant="outlined"
                                size="small"
                                sx={{ width: "20vw" }}
                                disabled={filterdepartment === "OP" || !formState?.selectedDoctorId}
                            />
                        )}
                    />
                    <TextField
                        size='small'
                        disabled={true}
                        value={formState?.serviceCharge}
                        id="drug-master"
                        sx={{ width: '20dvw', mr: '5vw' }}
                        label={"Service Charge *"}
                        InputProps={true ? {
                            style: { paddingRight: '1vw' },
                            endAdornment:
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography>
                        } : null}
                        variant="outlined"
                    />
                    <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                    <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={!commonDisable} onClick={() => { addAutoBilling() }}>{'Add'}</Button>
                </Box>
                {/* </Box> */}
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: "end" }}>

                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '58vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={DeleteAutoBillingData}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}